<form [formGroup]="form"
  class="chat-container collapsible-chat flex flex-col h-full w-full max-w-md mx-auto bg-gray-100 p-4 rounded-lg shadow-lg">
  <div class="chat-header flex items-center p-4 bg-cdi-freelancer-01 rounded-t-lg">
    <img src="./assets/images/bot.png" alt="Chatbot" class="chat-icon w-10 h-10 rounded-full mr-3">
    <div>
      <h2 class="chat-title text-white font-semibold">CDIWork Support Center</h2>
      <!-- <div class="chat-subtitle flex items-center text-sm text-blue-200">
        <div class="status-icon w-2 h-2 rounded-full bg-green-400 mr-1"></div>
        <span>Online</span>
      </div> -->
    </div>
  </div>
  <div class="chat-content flex-1 overflow-y-auto p-4 space-y-4" #messageContainer>
    <form [formGroup]="form">
      <fieldset class="mt-4">
        <span class="font-bold mb-3">Type of User</span>
        <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
          <div class="flex items-center">
            <input type="radio" formControlName="user_type" name="user_type" value="freelancer"
              (click)="changeUser('freelancer')"
              class="h-4 w-4 border-gray-300 color-cdi-client-03 focus:ring-indigo-500" required>
            <label for="aba" class="ml-3 block text-sm font-medium text-gray-700">Freelancer</label>
          </div>
          <div class="flex items-center">
            <input type="radio" formControlName="user_type" name="user_type" value="client"
              (click)="changeUser('client')" class="h-4 w-4 border-gray-300 color-cdi-client-03 focus:ring-indigo-500"
              required>
            <label for="swift_code" class="ml-3 block text-sm font-medium text-gray-700">Client</label>
          </div>
        </div>
      </fieldset>
    </form>
    <div class="mx-auto divide-y divide-gray-900/10" *ngIf="freelancerFAQ">
      <h2 class="text-1xl font-normal leading-10 tracking-tight color-cdi-freelancer-01">Frequently asked questions</h2>
      <dl class="mt-10 space-y-6 divide-y divide-gray-900/10">
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(1)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">Should I have to register on CDIWork?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 1 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 1 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 1">
            <p class="text-base leading-7 text-gray-600">
              To register, follow these steps: Begin by completing the quick and straightforward registration process,
              which usually takes only a few minutes. Make sure to have your mobile device ready, as a One Time Password
              (OTP) will be sent to it. Enter the OTP received on your mobile to verify your account. Provide any
              additional information requested during the registration process. Agree to the terms and conditions.
              Finally, click the "Sign Up" button to complete the registration.
            </p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(2)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">How can I build my profile?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 2 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 2 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 2">
            <p class="text-base leading-7 text-gray-600">You are encouraged to input your personal details, including
              your name, date of birth, gender, country, title, educational background, and work experience. Feel free
              to upload your resume and share other pertinent external links to showcase your professional background.
              Enjoy the flexibility of editing your profile at any time to keep it up-to-date. Enhance your online
              presence by personalizing your account with a profile picture.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(3)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">What is the process for submitting a job
                application?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 3 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 3 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 3">
            <p class="text-base leading-7 text-gray-600">Once you meet the job requirements, you can present your
              proposal to the client, specifying the duration and cost. If the client accepts, you move on to the
              contract phase. In case of rejection, you can reissue your proposal until the client accepts either your
              bid or that of another freelancer.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(4)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">When am I going to start earning?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 4 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 4 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 4">
            <p class="text-base leading-7 text-gray-600">Ensure timely delivery of the project according to the
              specified contract timeline. Maintain consistent communication with your client using the messaging
              feature. Upon the client's acceptance of the successful delivery, payment will be credited to your wallet,
              accompanied by an additional reward of 20 C-Coins. Provide a "rating" and "review" for the client based on
              your experience. In the event of rejection, redeliver your files promptly or submit a "request for
              extension" before the specified timeline expires. If the timeline lapses without successful delivery or
              client acceptance, the contract will be automatically "Cancelled," negatively impacting your ranking, and
              50 C-Coins will be deducted from your wallet.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(5)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">Can I get an explanation on wallet management?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 5 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 5 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 5">
            <p class="text-base leading-7 text-gray-600">Access information about your available funds directly in your
              wallet. To initiate fund withdrawal, it is essential to provide and verify your bank details by selecting
              the "Add Bank" option.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(6)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">Please explain more about C-Coins? </span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 6 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 6 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 6">
            <p class="text-base leading-7 text-gray-600">C-Coins are needed to apply for a particular job. Each month,
              there will be monthly C-Coin gifts but you can purchase additional coins directly from your wallet.
              Facilitate coin transfers to others and receive C-Coins from them. Be mindful that some coins may expire
              if no activities occur within the entire month. Enhance your profile visibility by opting to boost it for
              10 C-Coins per month.</p>
          </dd>
        </div>
      </dl>
    </div>
    <div class="mx-auto divide-y divide-gray-900/10" *ngIf="clientFAQ">
      <h2 class="text-1xl font-normal leading-10 tracking-tight color-cdi-client-03">Frequently asked questions</h2>
      <dl class="mt-10 space-y-6 divide-y divide-gray-900/10">
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(1)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">How can I register on CDIWork?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 1 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 1 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 1">
            <p class="text-base leading-7 text-gray-600">
              To start, registration is mandatory, and it's a swift process, usually requiring just a few minutes. Have
              your mobile device ready, as a One Time Password (OTP) will be sent to it. Verify your account by entering
              the received OTP. Fill in any additional details requested during registration, and consent to the terms
              and conditions.
            </p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(2)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">What are the steps for posting a job?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 2 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 2 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 2">
            <p class="text-base leading-7 text-gray-600">You can post your first three jobs at no cost. For your fourth
              job and beyond, you'll need to recharge your wallet and choose a package. Visit the "My Jobs" client_tab,
              and select the "post a job" button. Fill in all the required sections according to your needs and proceed
              to publish the job. The job's status will be labeled as "Open." You retain the flexibility to review and
              adjust your posted jobs anytime before entering into a contract with a freelancer</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(3)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">Where can I get the list of available freelancers?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 3 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 3 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 3">
            <p class="text-base leading-7 text-gray-600">To leverage the diverse pool of freelancers, begin by exploring
              available talent through the search feature, refining your search by specific categories to find the
              perfect match for your project. Review the list of applicants for your posted job, click on individual
              freelancers for detailed profile views, and initiate chats to assess their skills. Extend invitations to
              selected freelancers directly from their profiles. After categorizing freelancers as "Qualified" or
              "Unqualified" based on detailed profiles, qualified freelancers submit bids, and you can either accept
              or reject them. Freelancers can resend bids until acceptance. Upon satisfaction and acceptance, an
              automatic contract initiation occurs, and your job status transitions to "Ongoing." This streamlined
              process ensures effective collaboration with the right freelancers for your projects.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(4)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">How can I follow-up my projects after I get into a
                contract with a freelancer? </span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 4 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 4 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 4">
            <p class="text-base leading-7 text-gray-600">Maintain seamless communication with the accepted freelancer by
              engaging in a chat throughout the project. The freelancer is required to submit deliverables within the
              designated timeline. Failure to meet the project due date automatically cancels the contract. Evaluate the
              deliverables and choose between "Satisfied" or "Unsatisfied." If unsatisfied, the freelancer can resend
              deliverables before the due date. In cases of extreme dissatisfaction, you can terminate the contract,
              resulting in a "Terminated" status. If satisfied, selecting "Satisfied" closes the project, marking it as
              "Completed," and the freelancer is compensated. If the project concludes without your selection, it is
              considered "Satisfied." If the timeline ends with "Unsatisfied" and no additional deliverables are
              received, the project is "Cancelled." Freelancers can request timeline extensions, subject to your
              approval or rejection.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(5)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">What is the use of CDIWork’s wallet?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 5 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 5 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 5">
            <p class="text-base leading-7 text-gray-600">To recharge your wallet, navigate to the "Wallet" in the
              client_tab, and select "recharge." Enter the required card details, and your wallet will be promptly
              recharged. All wallet activities are transparently displayed for your convenience, facilitating easy
              record-keeping and tracking.</p>
          </dd>
        </div>
        <div class="pt-6">
          <dt>
            <button type="button" (click)="expandAnswer(6)"
              class="flex w-full items-start justify-between text-left text-gray-900" aria-controls="faq-0"
              aria-expanded="false">
              <span class="text-base font-semibold leading-7">Should I choose a package to post a job?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 6 ? 'hidden' : ''" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg class="h-6 w-6" [ngClass]="showAnswer && currentQuestion === 6 ? 'block' : 'hidden'" fill="none"
                  viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12" id="faq-0" *ngIf="showAnswer && currentQuestion === 6">
            <p class="text-base leading-7 text-gray-600">Your first three job postings come at no charge. However,
              starting with the fourth post, you'll need to subscribe to a specific "package." Multiple packages,
              including silver, gold, platinum, etc., are accessible. Once your current package expires, renewal is
              essential, and you can choose to stick with the same package or opt for a different one.</p>
          </dd>
        </div>
      </dl>
    </div>
    <button class="text-sky-600" (click)="contactSupport()">Contact Support Center</button>
  </div>

  <div *ngIf="showMessageWritter" class="chat-actions flex items-center p-4 border-t border-gray-300">
    <div class="flex-grow relative">
      <textarea
        class="chat-input w-full p-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:border-blue-500"
        placeholder="Type message..." formControlName="message" (keydown.enter)="onClickEnter($event)"
        rows="1"></textarea>
    </div>
    <button class="send-button ml-2 p-2 bg-cdi-client-03 text-white rounded-full" aria-label="Send"
      (click)="onClickSendMessage()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M14.752 11.168l-9.192-5.32a.75.75 0 00-1.124.65v10.004a.75.75 0 001.124.65l9.192-5.32a.75.75 0 000-1.3z" />
      </svg>
    </button>
  </div>
</form>
